import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { StoreClassEntryStateData } from "~/gql/graphqlBase.generated";

interface StoreClassState {
	formOpen: boolean;
	selectedStoreClass: StoreClassEntryStateData | null;
}

const initialState: StoreClassState = {
	formOpen: false,
	selectedStoreClass: null
};

const storeClassSlice = createSlice({
	initialState,
	name: "storeClass",
	reducers: {
		closeStoreClassForm: (state) => {
			state.formOpen = false;
			state.selectedStoreClass = null;
		},
		openStoreClassForm: (state) => {
			state.formOpen = true;
		},
		setSelectedStoreClass: (state, action: PayloadAction<StoreClassEntryStateData | null>) => {
			state.selectedStoreClass = action.payload;
		}
	}
});

export const { closeStoreClassForm, openStoreClassForm, setSelectedStoreClass } = storeClassSlice.actions;

export default storeClassSlice.reducer;
